import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {UmsatzsteuerschluesselExtended} from '../../interfaces/umsatzsteuerschluessel-extended.interface';


export const umsatzsteuerschluesselEntitiesAdapter: EntityAdapter<UmsatzsteuerschluesselExtended> = createEntityAdapter<UmsatzsteuerschluesselExtended>({
  selectId: (umsatzsteuerschluessel: UmsatzsteuerschluesselExtended) => umsatzsteuerschluessel.betriebId + '-' + umsatzsteuerschluessel.nummer,
});
